// mutations

import router from '@/router'

const CAFETERIA_REQUESTS_ALL = (state, cafeteriaRequests) => {
  if (cafeteriaRequests.code === 1) {
    state.cafeteriaRequests = cafeteriaRequests.data
    state.status = 'success'
  } else {
    alert(cafeteriaRequests.message)
    state.status = 'error'
  }
}

const CAFETERIA_REQUESTS_FORM = (state, cafeteriaRequests) => {
  if (cafeteriaRequests.code === 1) {
    state.cafeteriaRequests = cafeteriaRequests.data
    state.status = 'success'
  } else {
    alert(cafeteriaRequests.message)
    state.status = 'error'
  }
}

const CAFETERIA_REQUESTS_SHOW = (state, cafeteriaRequests) => {
  if (cafeteriaRequests.code === 1) {
    state.cafeteriaRequests = cafeteriaRequests.data
    state.status = 'success'
  } else {
    alert(cafeteriaRequests.message)
    state.status = 'error'
  }
}

const CAFETERIA_REQUESTS_CREATE = (state, cafeteriaRequests) => {
  if (cafeteriaRequests.code === 1) {
    state.cafeteriaRequests = cafeteriaRequests.data
    state.status = 'success'
    alert(cafeteriaRequests.message)
  } else {
    alert(cafeteriaRequests.message)
    state.status = 'error'
  }
}

const CAFETERIA_REQUESTS_UPDATE = (state, cafeteriaRequests) => {
  if (cafeteriaRequests.code === 1) {
    state.cafeteriaRequests = cafeteriaRequests.data
    state.status = 'success'
    alert(cafeteriaRequests.message)
  } else {
    alert(cafeteriaRequests.message)
    state.status = 'error'
  }
}

const CAFETERIA_REQUESTS_DELETE = (state, cafeteriaRequests) => {
  if (cafeteriaRequests.code === 1) {
    state.cafeteriaRequests = cafeteriaRequests.data
    state.status = 'success'
    alert(cafeteriaRequests.message)
  } else {
    alert(cafeteriaRequests.message)
    state.status = 'error'
  }
}

const CAFETERIA_REQUESTS_VALIDATE = (state, cafeteriaRequests) => {
  let json = JSON.stringify(cafeteriaRequests.data)
  //localStorage.setItem('requestValidate', json)
  if (cafeteriaRequests.code === 1) {
    state.cafeteriaRequests.credential = cafeteriaRequests.data
    router.push('/cafeteria/requests/recreate')
    state.status = 'success'
  } else {
    alert(cafeteriaRequests.message)
    state.status = 'error'
  }
}

const CARNETS_REQUESTS_VALIDATE = (state, cafeteriaRequests) => {
  let json = JSON.stringify(cafeteriaRequests.data)
  //localStorage.setItem('requestValidate', json)
  if (cafeteriaRequests.code === 1) {
    state.cafeteriaRequests.credential = cafeteriaRequests.data
    let credential = cafeteriaRequests.data
    router.push('/admin/carnets/recargar/'+credential.id)
    //router.push('/cafeteria/requests/recreate')
    state.status = 'success'
  } else {
    alert(cafeteriaRequests.message)
    state.status = 'error'
  }
}

const CARNETS_REQUESTS_VALIDATE_DISCOUNT = (state, cafeteriaRequests) => {
  let json = JSON.stringify(cafeteriaRequests.data)
  //localStorage.setItem('requestValidate', json)
  if (cafeteriaRequests.code === 1) {
    state.cafeteriaRequests.credential = cafeteriaRequests.data
    let credential = cafeteriaRequests.data
    router.push('/admin/carnets/descarga/'+credential.id)
    //router.push('/cafeteria/requests/recreate')
    state.status = 'success'
  } else {
    alert(cafeteriaRequests.message)
    state.status = 'error'
  }
}

export default {
  CAFETERIA_REQUESTS_ALL,
  CAFETERIA_REQUESTS_FORM,
  CAFETERIA_REQUESTS_SHOW,
  CAFETERIA_REQUESTS_CREATE,
  CAFETERIA_REQUESTS_UPDATE,
  CAFETERIA_REQUESTS_DELETE,
  CAFETERIA_REQUESTS_VALIDATE,
  CARNETS_REQUESTS_VALIDATE,
  CARNETS_REQUESTS_VALIDATE_DISCOUNT
}



// WEBPACK FOOTER //
// ./src/store/modules/cafeteria/requests/mutations.js